namespace GeniuzPOS.Inventory {
    export interface IcStockApproveSetAssembleForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        WhsSet: Serenity.LookupEditor;
        WhsItem: Serenity.LookupEditor;
        SetItemCode: Serenity.LookupEditor;
        SetQty: Serenity.DecimalEditor;
        ApproveFg: Serenity.EnumEditor;
        ApproveBy: Serenity.StringEditor;
        ApproveDate: Serenity.DateEditor;
        Remark: Serenity.StringEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        IcStockApproveSetAssembleDtList: IcStockApproveSetAssembleDtEditor;
    }

    export class IcStockApproveSetAssembleForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockApproveSetAssemble';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockApproveSetAssembleForm.init)  {
                IcStockApproveSetAssembleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.EnumEditor;
                var w5 = IcStockApproveSetAssembleDtEditor;

                Q.initFormType(IcStockApproveSetAssembleForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'WhsSet', w2,
                    'WhsItem', w2,
                    'SetItemCode', w2,
                    'SetQty', w3,
                    'ApproveFg', w4,
                    'ApproveBy', w0,
                    'ApproveDate', w1,
                    'Remark', w0,
                    'PostFg', w4,
                    'CancelFg', w4,
                    'IcStockApproveSetAssembleDtList', w5
                ]);
            }
        }
    }
}
